/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {useQueryResponseLoading, useQueryResponsePagination} from '../../core/QueryResponseProvider'
import {useQueryRequest} from '../../core/QueryRequestProvider'

const mappedLabel = (label: string): string => {
  if (label === '&laquo; Previous') {
    console.log("🚀 ~ file: UsersListPagination.tsx:8 ~ mappedLabel ~ label", label)
    return 'Previous'
  }

  if (label === 'Next &raquo;') {
    console.log("🚀 ~ file: UsersListPagination.tsx:13 ~ mappedLabel ~ label", label)
    
    return 'Next'
  }
  console.log("🚀 ~ file: UsersListPagination.tsx:13 ~ mappedLabel ~ label", label)
  return label
}

const UsersListPagination = () => {
  const pagination = useQueryResponsePagination()
  const isLoading = useQueryResponseLoading()
  const {updateState} = useQueryRequest()
  const updatePage = (page: number | null) => {
    if (!page || isLoading) {
      return
    }

    return updateState({page, limit:  10})
  }
  console.log(pagination.links)

  return (
    <div className='row'>
      <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'></div>
      <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
        <div id='kt_table_users_paginate'>
          <ul className='pagination'>
            {pagination.links
              ?.map((link:any) => {
                return {...link, label: mappedLabel(link.label)}
              })
              .map((link:any) => (
                <li
                  key={link.label}
                  className={clsx('page-item', {
                    active: link.current_page === link.page,
                    disabled: isLoading,
                    previous: link.label === 'Previous',
                    next: link.label === 'Next',
                  })}
                >
                  <a
                    className={clsx('page-link', {
                      'page-text': link.label === 'Previous'
                                || link.label === 'Next',
                      'me-5'     : link.label === 'Previous',
                    })}
                    onClick={() => updatePage(link.label)}
                    style={{cursor: 'pointer'}}
                  >
                    {mappedLabel(link.label)}
                  </a>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </div>
  )
}
export {UsersListPagination}